import {isWithoutRegistration} from '@wix/wix-events-commons-statics'
import {isMobile} from '../../../../../../commons/selectors/environment'
import {
  getButtonHeight,
  getOneButtonWidth,
  getRsvpButtonMargin,
  isOnlyButtonVisible,
  isOnImageLayout,
  isRsvpLabelVisible,
} from '../../../selectors/single-settings'
import {hasEventDetailsUrl, isEventRestricted} from '../../../selectors/events'
import {AppProps} from '../../app/interfaces'
import {withMargin} from '../../hoc/with-margin'
import {connect} from '../../runtime-context/connect'
import {getComponentConfig, isResponsive} from '../../../selectors/settings'
import {RsvpButton as RsvpButtonPresentation} from './rsvp-button'
import {RsvpButtonOwnProps, RsvpButtonStateProps} from './interfaces'

const mapState = ({state, actions}: AppProps, {event}: RsvpButtonOwnProps): RsvpButtonStateProps => {
  const componentConfig = getComponentConfig(state)

  return {
    rsvpLabelVisible: isRsvpLabelVisible(state),
    width: isMobile(state) ? undefined : getOneButtonWidth(componentConfig),
    height: isMobile(state) ? undefined : getButtonHeight(componentConfig),
    onImage: isOnImageLayout(state),
    isMobile: isMobile(state),
    responsiveButton: isResponsive(componentConfig) && isOnlyButtonVisible(state),
    hidden: isWithoutRegistration(event),
    hasUrl: hasEventDetailsUrl(state, event),
    navigateToPage: () => actions.navigateToPage(event),
    settings: componentConfig.settings,
    ensureLoginAndNavigateToPage: () => actions.ensureLoginAndNavigateToPage(event),
    eventRestricted: isEventRestricted(state, event),
  }
}

const getMargin = ({state}: AppProps) => getRsvpButtonMargin(state)

export const RsvpButton = withMargin(
  connect<RsvpButtonOwnProps, RsvpButtonStateProps>(mapState)(RsvpButtonPresentation),
  getMargin,
)
export * from './interfaces'
